import React from 'react';
import { useLocation } from 'wouter';

import DndClientForm from './dndForm/ClientForm';
import FbClientForm from './fbForm/ClientForm';
import FhbfCounselingCenterClientForm from './fhbfForm/counselingCenter/CounselingCenterClientForm';
import FhbfInterventionCenterClientForm from './fhbfForm/interventionCenter/InterventionCenterClientForm';
import FhfClientForm from './fhfForm/ClientForm';
import type { Client } from '../../common/types/client';

type Props = {
  clientId: string;
  client: Client;
  updateClient: (client: Client) => void;
  saveClient: (client: Client) => void;
};

const reactAppVersion = process.env.REACT_APP_VERSION;

function ClientForm(props: Props) {
  const [location] = useLocation();

  if (reactAppVersion === 'dnd') {
    return <DndClientForm client={props.client} updateClient={props.updateClient} />;
  }
  if (reactAppVersion === 'fb') {
    return <FbClientForm client={props.client} updateClient={props.updateClient} saveClient={props.saveClient} />;
  }
  if (reactAppVersion === 'fhbf' && location.includes('fachberatungsstelle')) {
    return (
      <FhbfCounselingCenterClientForm
        client={props.client}
        updateClient={props.updateClient}
        saveClient={props.saveClient}
      />
    );
  }
  if (reactAppVersion === 'fhbf' && location.includes('interventionsstelle')) {
    return (
      <FhbfInterventionCenterClientForm
        client={props.client}
        updateClient={props.updateClient}
        saveClient={props.saveClient}
      />
    );
  }
  if (reactAppVersion === 'fhf') {
    return (
      <FhfClientForm
        clientId={props.clientId}
        client={props.client}
        updateClient={props.updateClient}
        saveClient={props.saveClient}
      />
    );
  }
  return <></>;
}

export default ClientForm;
